import React, { useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
const WidgetVisualizationNotFound = ({ widgetClassName }) => {
  const { t } = useTranslation("common");
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => onRenderComplete(), [onRenderComplete]);
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "widget_visualization_not_found.description",
      values: { widgetClassName },
      components: { italic: /* @__PURE__ */ React.createElement("i", null) }
    }
  ));
};
export default WidgetVisualizationNotFound;
